app.controller('authCheckController',
  ['authHelper', 'portalHelper', 'apiHelper', 'HttpAuth', '$location',
    function (authHelper, portalHelper, apiHelper, HttpAuth, $location) {
      if (authHelper.isPublicRoute()) {
        return;
      }

      const checkIf2FARequired = function (myDetails) {
        if (myDetails.tfa_mandatory && !myDetails.tfa_configured) {
          let redirectUrl = $location.protocol() + '://' + $location.host();
          if ($location.port()) {
            redirectUrl += (':' + $location.port() + '/#');
          }
          window.location.href = apiHelper.getApiUrl() + '/auth/setup-tfa/?next=' + redirectUrl;
        }
      };

      authHelper.isLoggedIn().then(
        function (result) {
          const myDetails = result.data;
          if (myDetails) {
            checkIf2FARequired(myDetails);
          }
        },
        function (result) {
          // firefox aborts the current requests in case we change the page
          // which result in logout
          if ('abort' != result.xhrStatus) {
            authHelper.doLogoutAll(true);
          }
        }
      );
    }
  ]
);
